import axios from 'axios';
import {BE_SERVER_ENDPOINT, API_PROTOCOL} from '../constants/configs.js';

export function sendMixpanelProperties(uuid , eventName ,data) {
    let request = {
        url : API_PROTOCOL + BE_SERVER_ENDPOINT + '/v2.0/dashboard/event/'+ eventName + '/users/' + uuid,
        data : data,
        method : 'POST'
    }
    axios(request)
}